import { useState } from "react";
import { Link } from "@/components/common/Link";
export default function FindAChurchSection() {
  const [searchValue, setSearchValue] = useState("");
  return <section style={{
    backgroundColor: "#F5F4F2",
    padding: "20px 16px 40px 16px"
  }} className="md:px-10 md:pb-12">
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Oswald:wght@400;500;600&family=Inter:wght@300;400;500;600&display=swap');`}</style>
      
      <div style={{
      borderRadius: "28px",
      display: "flex",
      alignItems: "stretch",
      justifyContent: "center",
      margin: "0 auto",
      overflow: "hidden",
      backgroundImage: "linear-gradient(90deg, rgba(1,139,185,1) 0%, rgba(27,106,170,1) 50%, rgba(52,73,154,1) 100%)",
      maxWidth: "1400px"
    }} className="flex-col md:flex-row shadow-lg">
        
        {/* Columna de texto y buscador */}
        <div className="flex flex-col w-full md:w-1/2 justify-center p-6 md:p-14">
          <h1 style={{
          color: "rgb(255, 255, 255)",
          fontFamily: "Switzer, Inter, sans-serif",
          fontSize: "clamp(32px, 5vw, 48px)",
          fontWeight: "400",
          lineHeight: "1.1",
          textTransform: "uppercase",
          marginBottom: "0"
        }}>
            ENCUENTRE UNA{" "}
            <span style={{
            display: "inline-block",
            backgroundColor: "rgb(255, 255, 255)",
            color: "rgb(53, 53, 51)",
            borderRadius: "28px",
            padding: "2px 16px",
            lineHeight: "normal",
            marginTop: "4px"
          }}>
              IGLESIA
            </span>
            <br />
            CERCA DE USTED
          </h1>

          <p style={{
          color: "rgb(255, 255, 255)",
          fontFamily: "Switzer, Inter, sans-serif",
          fontSize: "16px",
          fontWeight: "300",
          lineHeight: "24px",
          marginTop: "24px",
          marginBottom: "0"
        }} className="md:text-lg md:leading-7">
            Use nuestro Directorio de Iglesias para encontrar una iglesia local de las Asambleas de Dios. Por favor ingrese cualquiera de los siguientes datos:
          </p>

          <div style={{
          marginTop: "24px",
          maxWidth: "560px",
          width: "100%"
        }}>
            <input type="text" placeholder="Nombre, Provincia, Cantón, o Pastor Principal" value={searchValue} onChange={e => setSearchValue(e.target.value)} style={{
            width: "100%",
            backgroundColor: "#F5F5F5",
            borderRadius: "8px",
            border: "none",
            padding: "14px 16px",
            fontSize: "15px",
            fontFamily: "Switzer, Inter, sans-serif",
            color: "#353533",
            outline: "none"
          }} />
          </div>

          <div style={{
          marginTop: "24px"
        }}>
            <button style={{
            color: "rgb(255, 255, 255)",
            fontFamily: "Switzer, Inter, sans-serif",
            fontSize: "14px",
            fontWeight: "500",
            lineHeight: "21px",
            backgroundColor: "rgb(53, 53, 51)",
            borderRadius: "28px",
            border: "1px solid rgb(53, 53, 51)",
            padding: "6px 6px 6px 16px",
            textTransform: "uppercase",
            textAlign: "center",
            cursor: "pointer",
            display: "inline-flex",
            alignItems: "center",
            gap: "8px"
          }}>
              BUSCAR IGLESIA
              <span style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: "24px",
              height: "24px",
              backgroundColor: "rgb(255, 255, 255)",
              borderRadius: "50%",
              color: "rgb(53, 53, 51)",
              flexShrink: 0
            }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="7" y1="17" x2="17" y2="7" />
                  <polyline points="7 7 17 7 17 17" />
                </svg>
              </span>
            </button>
          </div>
        </div>

        {/* Columna de la imagen */}
        <div className="w-full md:w-1/2 min-h-[300px] md:min-h-[450px]" style={{
        position: "relative"
      }}>
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/Woman_Worship.jpg" alt="Woman worshipping" loading="lazy" style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          display: "block"
        }} />
        </div>
      </div>
    </section>;
}